import QRCode from "qrcode";

type QRCodeOptions = {
  width?: number;
  margin?: number;
  errorCorrectionLevel?: "L" | "M" | "Q" | "H";
};

/**
 * Generates a QR code as a Data URL (base64 encoded PNG)
 * Suitable for embedding in emails and web pages
 */
export async function QRCode__DataUrl(
  data: string,
  options: QRCodeOptions = {}
): Promise<string> {
  const { width = 200, margin = 2, errorCorrectionLevel = "M" } = options;

  try {
    const dataUrl = await QRCode.toDataURL(data, {
      width,
      margin,
      errorCorrectionLevel,
      color: {
        dark: "#000000",
        light: "#ffffff",
      },
    });
    return dataUrl;
  } catch (error) {
    console.error("Error generating QR code:", error);
    throw error;
  }
}

/**
 * Generates a QR code as an SVG string
 * Suitable for web display with better quality at any size
 */
export async function QRCode__SVGString(
  data: string,
  options: QRCodeOptions = {}
): Promise<string> {
  const { width = 200, margin = 2, errorCorrectionLevel = "M" } = options;

  try {
    const svgString = await QRCode.toString(data, {
      type: "svg",
      width,
      margin,
      errorCorrectionLevel,
      color: {
        dark: "#000000",
        light: "#ffffff",
      },
    });
    return svgString;
  } catch (error) {
    console.error("Error generating QR code SVG:", error);
    throw error;
  }
}

/**
 * Generates a QR code for a booking ID
 * This is a convenience function that prefixes the booking ID
 * to make it identifiable when scanned
 */
export async function BookingQRCode__DataUrl(
  bookingId: string,
  options: QRCodeOptions = {}
): Promise<string> {
  return QRCode__DataUrl(bookingId, options);
}

/**
 * Generates a QR code SVG for a booking ID
 */
export async function BookingQRCode__SVGString(
  bookingId: string,
  options: QRCodeOptions = {}
): Promise<string> {
  return QRCode__SVGString(bookingId, options);
}
